/**
 * Default Strategy
 * 
 * This is the fallback strategy used when no specific strategy is available for a topic.
 * It provides a basic implementation that can handle any topic.
 */

import { createDefaultStrategy } from './baseStrategy';

/**
 * Default strategy for topics without a specific strategy
 * Uses the base strategy with default implementations of all phases
 */
const defaultStrategy = createDefaultStrategy('default');

export default defaultStrategy;
